import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CommonLoader from '../../../../components/common-loader/CommonLoader';
import CommonPagination from '../../../../components/common-pagination/CommonPagination';
import UploadCard from '../upload-card/UploadCard';
import FrameCard from '../../frames/card/FrameCard';
import { useProject } from '../../../../context/ProjectContext';
import { PROJECT_VARIANTS, PROMPT_TYPE } from '../../../../constants';
import { changeAdImagesTable } from '../../../../redux/id8/id8Reducer';
import PhotoPreview from '../../frames/photo-preview/PhotoPreview';
import imageReactionHelper from '../../../utils/imageReactionHelper';
import SourceImageModal from '../../source-image-modal/SourceImageModal';
import { getConsumerSourceImage, getSourceImage } from '../../../../utils/id8ImagesRequests';

import scss from './RecreateOutput.module.scss';

function RecreateOutput({ onShowUploadModal }) {
  const dispatch = useDispatch();
  const [imagesPreview, setImagesPreview] = useState(null);
  const [sourceImageId, setSourceImageId] = useState('');

  const { actions } = useProject();

  const imagesContent = useSelector((state) => state.id8.adImagesContent);
  const { page, size, totalElements } = useSelector((state) => state.id8.adImagesTableSettings);
  const isImagesLoading = useSelector((state) => state.id8.isAdImagesLoading);
  const { projectVariant } = useProject();
  const { projectName, projectPassword } = useSelector((state) => state.consumer.id8);

  const handleClosePreview = () => {
    setImagesPreview(null);
  };

  const handleOpenPreview = ({ frameData, initialIndex }) => {
    setImagesPreview({ frameData, initialIndex });
  };

  const handleLike = (likedImage) => {
    const { newReaction, newUpdatedOn, previewCallback } = imageReactionHelper(likedImage);
    actions('likeImage', {
      imageId: likedImage.id,
      newReaction,
      updatedOn: newUpdatedOn,
      promptType: PROMPT_TYPE.RECREATE,
    });

    // if (imagesPreview) {
    //   setImagesPreview(previewCallback);
    // }
  };

  const handleDownload = (id) => {
    actions('downloadImage', id);
  };

  const handleChangePage = (newPage) => {
    dispatch(changeAdImagesTable({ page: newPage + 1 }));
  };

  const handleShowSourceImage = (prompt) => {
    setSourceImageId(prompt.id);
  };

  const handleCloseSourceImageModal = () => {
    setSourceImageId('');
  };

  const handleRevise = async (values) => {
    await actions('reviseImage', values);
  };

  const handleGetImage = (promptId) => {
    if (projectVariant === PROJECT_VARIANTS.ADMIN) {
      return getSourceImage(promptId);
    }

    if (projectVariant === PROJECT_VARIANTS.CONSUMER) {
      return getConsumerSourceImage(promptId, { projectName, projectPassword });
    }
  };

  useEffect(() => {
    if (imagesPreview) {
      const updatedFrameData = imagesContent.find((frame) => frame.id === imagesPreview.frameData.id);
      if (updatedFrameData) {
        setImagesPreview((prev) => ({
          ...prev,
          frameData: updatedFrameData,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesContent]);

  return (
    <div className={scss.wrapper}>
      <div className={scss.cardsWrapper}>
        {!imagesContent.length ? <UploadCard onShowUploadModal={onShowUploadModal} /> : null}

        {imagesContent.map((frameData) => (
          <FrameCard
            key={frameData.id}
            frameData={frameData}
            onPreview={handleOpenPreview}
            onDownload={handleDownload}
            onLike={handleLike}
            onShowSourceImage={handleShowSourceImage}
          />
        ))}

        <CommonLoader isLoading={isImagesLoading} />
      </div>

      <CommonPagination
        activePage={page - 1}
        itemsPerPage={size}
        totalItemsCount={totalElements}
        onChangePage={handleChangePage}
      />

      <PhotoPreview
        isOpen={imagesPreview}
        onClose={handleClosePreview}
        imagePreview={imagesPreview}
        onDownload={handleDownload}
        onLike={handleLike}
        onShowSourceImage={handleShowSourceImage}
        onRevise={handleRevise}
      />

      <SourceImageModal
        isOpen={!!sourceImageId}
        onClose={handleCloseSourceImageModal}
        sourceImageId={sourceImageId}
        onGetImage={handleGetImage}
      />
    </div>
  );
}

export default RecreateOutput;
